module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-disco.b2344135.jpg";